import axios from 'axios';


export const fetchCourseMaterial = (course_id) => {
    return axios.get(`/api/courses/${course_id}`)
}